__turbopack_context__.v({
  "checked": "Pill-module__Yy6QsG__checked",
  "main": "Pill-module__Yy6QsG__main",
});
